import { Globe } from 'lucide-react';
import { useCurrency } from '../hooks/useCurrency';
import { CURRENCY_META, type Currency } from '../lib/pricing';

/**
 * Minimal currency selector. Rendered on the Pricing page (and anywhere else
 * a price is shown that the user might want to flip). The detection heuristic
 * will cover most users, but a traveller in Singapore who wants to pay in
 * their home INR should be able to say so.
 */
export default function CurrencyPicker({ className = '' }: { className?: string }) {
  const { currency, setCurrency } = useCurrency();
  const options = Object.values(CURRENCY_META);

  return (
    <label className={`inline-flex items-center gap-1.5 text-sm text-ink-600 ${className}`}>
      <Globe className="w-4 h-4 text-ink-400" />
      <span className="sr-only">Currency</span>
      <select
        className="bg-transparent border border-ink-200 rounded-lg px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-brand-200"
        value={currency}
        onChange={(e) => setCurrency(e.target.value as Currency)}
        aria-label="Display currency"
      >
        {options.map((c) => (
          <option key={c.code} value={c.code}>
            {c.symbol} {c.code.toUpperCase()} · {c.label}
          </option>
        ))}
      </select>
    </label>
  );
}
